import VueWrapper from '@/components/core/Vue/vue.wrapper';
import BaseFormComponent from '@/components/vuetify/Form/base-form';
import {PIN_DIRECTION} from '@/globals';
import {CreateEditEquipmentPinViewModel, EquipmentPinModel, TerminalBlockModel} from '@/sdk';
import {EquipmentPinsApi, TerminalBlockApi} from '@/sdk/api-services';
import {Component, Prop, Watch} from 'vue-property-decorator';

@Component({
    name: 'PinDetailsFormComponent',
})
export default class PinDetailsFormComponent extends VueWrapper {
    @Prop({
        type: String,
        required: true,
    })
    public readonly selectedLocationId!: string;

    @Prop({
        type: Object,
        default: null,
    })
    public readonly selectedPin!: EquipmentPinModel | null;

    @Prop({
        type: Boolean,
        default: false,
    })
    public readonly readonly!: boolean;

    @Prop({
        type: String,
        default: PIN_DIRECTION.IN,
    })
    public readonly defaultPinDirection!: PIN_DIRECTION;

    public $refs!: {
        pinFormRef: BaseFormComponent;
    };

    public equipmentPinsApi: EquipmentPinsApi = new EquipmentPinsApi();
    public terminalBlockApi: TerminalBlockApi = new TerminalBlockApi();
    public isLoading: boolean = false;

    public terminalBlocks: TerminalBlockModel[] = [];

    public pinTypes: string[] = ['Terminal', 'Earthing Point', 'Bonding Point'];

    public pinForm: CreateEditEquipmentPinViewModel = new CreateEditEquipmentPinViewModel({
        title: '',
        pinDirection: this.defaultPinDirection,
        pinType: undefined,
        // equipmentCapId: undefined,
        connectedPinId: undefined,
        sortOrder: 1,
    });

    public get isEditing(): boolean {
        return !!this.selectedPin && !!this.selectedPin.id;
    }

    public get pinDirectionDisplay(): string {
        if (!this.selectedPin?.pinDirection) {
            return this.defaultPinDirection;
        }
        return this.selectedPin.pinDirection === PIN_DIRECTION.IN ? 'In' : 'Out';
    }

    public mounted(): void {
        this.loadPinData();
        this.getTerminalBlocksOfLocation();
    }

    public getTerminalBlocksOfLocation() {
        // this.LoaderSrv.showFullScreenLoader('Loading terminal blocks...');
        // this.terminalBlockApi
        //     .getByLocationId(this.selectedLocationId)
        //     .then(blocks => {
        //         this.terminalBlocks = blocks;
        //     })
        //     .catch(error => {
        //         console.error('Error fetching terminal blocks:', error);
        //     })
        //     .finally(() => {
        //         this.LoaderSrv.hideFullScreenLoader();
        //     });
    }

    @Watch('selectedPin', {deep: true})
    public onSelectedPinChanged(): void {
        this.loadPinData();
    }

    @Watch('selectedLocationId')
    public onSelectedLocationIdChanged(): void {
        this.getTerminalBlocksOfLocation();
    }

    public getEquipmentCapTitle(capId: string): string {
        // This method would need to be implemented to get cap title from the parent component
        // or through a service call. For now, return the ID.
        return `Cap ${capId}`;
    }

    public getConnectedPinTitle(pinId: string): string {
        // This method would need to be implemented to get connected pin title
        // or through a service call. For now, return the ID.
        return `Pin ${pinId}`;
    }

    private loadPinData(): void {
        if (this.selectedPin) {
            this.pinForm = new CreateEditEquipmentPinViewModel({
                id: this.selectedPin.id,
                title: this.selectedPin.title || '',
                pinDirection: this.selectedPin.pinDirection || this.defaultPinDirection,
                pinType: this.selectedPin.pinType || undefined,
                // equipmentCapId: this.selectedPin.equipmentCapId || undefined,
                // terminalBlockId: this.selectedPin.terminalBlockId || undefined,
                connectedPinId: this.selectedPin.connectedPinId || undefined,
                sortOrder: this.selectedPin.sortOrder || 1,
            });
        } else {
            this.resetForm();
        }
    }

    public async savePin(): Promise<void> {
        if (!this.$refs.pinFormRef.validate() || this.isLoading) {
            return;
        }

        try {
            this.isLoading = true;

            if (this.isEditing && this.selectedPin?.id) {
                // Update existing pin
                await this.equipmentPinsApi.updatePin(this.selectedLocationId, this.selectedPin.id, this.pinForm);

                this.AlertSrv.show('success', 'Pin updated successfully!');
                this.$emit('pin-updated', this.selectedPin.id);
            } else {
                // Create new pin
                const newPin = await this.equipmentPinsApi.createPin(this.selectedLocationId, this.pinForm);

                this.AlertSrv.show('success', 'Pin created successfully!');
                this.$emit('pin-created', newPin);
                this.resetForm();
            }
        } catch (error: any) {
            console.error('Error saving pin:', error);
            this.AlertSrv.show('error', error?.message || 'Failed to save pin. Please try again.');
        } finally {
            this.isLoading = false;
        }
    }

    public resetForm(): void {
        this.pinForm = new CreateEditEquipmentPinViewModel({
            title: '',
            pinDirection: this.defaultPinDirection,
            pinType: undefined,
            // equipmentCapId: undefined,
            terminalBlockId: undefined,
            connectedPinId: undefined,
            sortOrder: 1,
        });

        this.$refs.pinFormRef?.reset();
        this.$emit('form-reset');
    }

    public validateForm(): boolean {
        return this.$refs.pinFormRef?.validate() || false;
    }
}
